<template>
    <div v-if="hasPermissionTo('list user')">
        <el-select 
            v-model="user_id"
            class="w-full"
            :multiple="multiple"
            :disabled="disabled || loading"
            :filter-method="filterOptions"
            default-first-option
            filterable
            :clearable="clearable"
            :placeholder="placeholder"
            :loading="loading"
            data-testid="aloai-user-selector"
            @clear="emitClearEvent"
            @change="emitChangeEvent"
            autocomplete="off">
            <el-option
                v-for="user in filteredUsers"
                :key="user.id"
                :label="user.name"
                :value="user.id">
                <div class="media">
                    <div class="media-body">
                        <label>{{ user.name }}</label>
                        <small>AloAi Agent</small>
                    </div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import auth from '../auth'
import * as User from '../constants/user'
import { acl_mixin } from '../mixins'

export default {
    name: 'alo-ai-user-selector',

    mixins: [acl_mixin],

    props: {
        value: {
            required: false,
            default: null
        },

        multiple: {
            type: Boolean,
            required: false,
            default: false
        },

        disabled: {
            default: false,
            type: Boolean,
            required: false
        },

        placeholder: {
            default: 'Select AloAi Agent'
        },

        clearable: {
            type: Boolean,
            required: false,
            default: true,
        }
    },

    data() {
        return {
            auth: auth,
            user_id: this.value,
            filtered_text: null,
            loading: false,
            users: [],
            User,
        }
    },

    computed: {
        ...mapState({
            current_company: state => state.cache.current_company,
        }),

        filteredUsers() {
            if (this.users && this.users.length > 0) {
                let filtered_users = this.users.filter((user) =>
                    !(user.role_names && user.role_names.length === 1 && user.read_only_access)
                )

                if (this.filtered_text) {
                    return filtered_users.filter((user) =>
                        (user.name && user.name.toLowerCase().includes(this.filtered_text.toLowerCase())) ||
                        (user.phone_number && user.phone_number.includes(this.filtered_text)) ||
                        (user.email && user.email.toLowerCase().includes(this.filtered_text.toLowerCase()))
                    )
                }

                return filtered_users
            }

            return []
        }
    },

    mounted() {
        this.fetchAloAiUsers()
    },

    methods: {
        async fetchAloAiUsers() {
            if (!this.hasPermissionTo('list user')) {
                return
            }

            this.loading = true
            try {
                const response = await axios.get('/api/v2/users', {
                    params: {
                        type: User.TYPE_AI_AGENT,
                        include_ai_users: true
                    }
                })
                this.users = response.data
            } catch (error) {
                console.error('Error fetching AloAi users:', error)
                this.users = []
            } finally {
                this.loading = false
            }
        },

        emitClearEvent() {
            this.$emit('clear')
        },

        emitChangeEvent(val) {
            this.$emit('change', val)
        },

        filterOptions(filterValue) {
            this.filtered_text = filterValue
        },
    },

    watch: {
        value() {
            this.user_id = this.value
        },

        user_id(val) {
            if (this.value !== undefined && this.user_id !== this.value) {
                this.$emit('change', val)
            }
        }
    }
}
</script> 
